<template>
  <div id="Index">
    <jw-navigation>
      <!-- 显示Banner -->
      <banner></banner>
      <!-- 显示信息查询 -->
      <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
        <div style="width: 20%;">
          <Menu theme="light" :active-name="activeName" :open-names="['1']" @on-select="onMenuChange">
            <MenuGroup title="证书查询">
              <MenuItem name="ranks">
                <Icon type="md-document" />
                级别证书
              </MenuItem>
              <MenuItem name="grades">
                <Icon type="md-ribbon" />
                段位证书
              </MenuItem>
            </MenuGroup>
            <MenuGroup title="教练员查询">
              <MenuItem name="trainer">
                <Icon type="ios-contacts" />
                教练员
              </MenuItem>
            </MenuGroup>
          </Menu>
        </div>
        <div style="width: 80%;padding: 20px;">
          <query-certificate v-if="activeName === 'ranks' || activeName === 'grades'" :cate="activeName" :show-query-button="true"></query-certificate>
          <query-trainer v-else></query-trainer>
        </div>
      </div>
    </jw-navigation>
  </div>
</template>

<script>
import Banner from "@/views/web/home/components/Banner";
import queryCertificate from "@/components/Query.vue";
import queryTrainer from "@/components/QueryTrainer.vue";

export default {
  name: "Index",
  components: {
    Banner,
    queryTrainer,
    queryCertificate
  },
  data() {
    return {
      activeName: 'ranks'
    }
  },
  methods: {
    onMenuChange(name) {
      this.activeName = name
    }
  }
}
</script>

<style scoped>

</style>
